import React, { useContext } from 'react';
import { AddressTypeTitle, AddressEditButton, AddressDeleteButton, AddressStarButton } from 'src/pages/AccountPage/components/AddressBlock/AddressBlock.style';
import { IAddressBlockProps } from 'src/pages/AccountPage/components/AddressBlock/AddressBlock.i';
import { AccountPagesContext } from 'src/lib/AccountPagesContext';

export const AddressBlock = ({ addr, formAction, setFormAction, blankForm, setForm, formId, addressTypeList }: IAddressBlockProps) => {
  const { getAddresses, account, countries, addresses } = useContext(AccountPagesContext);

  async function updatePrimary(newID) {
    const oldID = addresses.filter((addr) => addr.AddressType === 'Primary')[0]?.AddressID;
    await fetch(`/api/account/address/makePrimary/${newID}/${oldID || -1}`, {
      credentials: 'include',
      method: 'PUT',
    });
    setTimeout(() => getAddresses(), 5);
  }

  function setFormData() {
    // clicking the edit button on the address already being edited. close form
    if(formAction === 'edit' && formId === addr.AddressID) {
      setFormAction(null);
      setForm(blankForm);
      return;
    }
    // open address form and prefill fields with current data
    setFormAction('edit');
    let newAddressTypeID;
    if(addr.AddressType == 'Primary') {
      newAddressTypeID = 1;
    } else {
      newAddressTypeID = addressTypeList.filter((type) => type.AddressType == addr.AddressType)[0]?.AddressTypeID || 10;
    }
    const newCountryID = countries.filter((country) => country.CountryName === addr.CountryName)[0]?.CountryID || 236;
    setForm({
      AddressType: addr.AddressType,
      AddressTypeID: newAddressTypeID,
      CountryID: newCountryID,
      State: addr.State,
      AddressID: addr.AddressID,
      Address: addr.Address,
      Address2: addr.Address2 || '',
      City: addr.City,
      Zip: addr.Zip,
      Province: addr.Province,
    });
  }

  async function handleDelete(AddressID) {
    await fetch(`/api/account/address/deleteAddress/${AddressID}`, {
      credentials: 'include',
      method: 'POST',
    });
    setTimeout(() => getAddresses(), 5);
    setFormAction(null);
  }

  const { AddressType, Address, Address2, City, State, Province, Zip, CountryName, AddressID } = addr;

  return (
    <div>
      <AddressTypeTitle>
        {AddressType} address
        <AddressEditButton onClick={() => setFormData()} title='Edit Address' />
        {AddressType !== 'Primary'
            && <>
              <AddressDeleteButton onClick={() => handleDelete(AddressID)} title='Delete Address' />
              <AddressStarButton onClick={() => updatePrimary(AddressID)} title='Make Primary' />
            </>
        }
      </AddressTypeTitle>
      <p>{account.BusinessName && account.BusinessName}</p>
      <p>{account.FirstName} {account.MI} {account.LastName}</p>
      <p>{Address}</p>
      <p>{Address2 && Address2}</p>
      <p>{City}, {State} {Province} {Zip}</p>
      <p>{CountryName}</p>
    </div>
  );
};
